module.exports = __webpack_public_path__ + "img/33_8.6758ccb5.png";